import request from '@/utils/request'

//  获取广告主列表
export function getAdvertiser(params = {}) {
  return request({
    url: `/release_report/advertiser_list_ad_name`,
    method: 'get',
    params
  })
}

// 获取绑定关系列表
export function getRelationsList(params = {}) {
  return request({
    url: `/ad_name_report/bind_relations`,
    method: 'get',
    params
  })
}

// 添加绑定关系
export function addRelations(data = {}) {
  return request({
    url: `/ad_name_report/bind_relations`,
    method: 'post',
    data
  })
}

// 修改绑定关系
export function modifyRelations(id, data = {}) {
  return request({
    url: `/ad_name_report/bind_relations/${id}`,
    method: 'PUT',
    data
  })
}

// 修改绑定关系状态
export function modifyRelationsStatus(data = {}) {
  return request({
    url: `/ad_name_report/set_bind_status`,
    method: 'PUT',
    data
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/ad_name_report/report_list`,
    method: 'get',
    params
  })
}

// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/ad_name_report/total_report`,
    method: 'get',
    params
  })
}
// 导出总计报表123
export function exportTotalReport(data = {}) {
  return request({
    url: `/ad_name_report/export_report_total`,
    method: 'POST',
    data
  })
}
// 导出列表报表123
export function exportReportList(data = {}) {
  return request({
    url: `/ad_name_report/export_report`,
    method: 'POST',
    data
  })
}

// 修改消耗123
export function modifyConsumption(data = {}) {
  return request({
    url: `/ad_name_report/set_cost`,
    method: 'PUT',
    data
  })
}

// 获取组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: `/ad_name_report/bind_groups`,
    method: 'get',
    params
  })
}
// 组添加
export function addReleaseGroup(data = {}) {
  return request({
    url: `/ad_name_report/bind_groups`,
    method: 'POST',
    data
  })
}
// 组修改
export function updateReleaseGroup(id, data = {}) {
  return request({
    url: `/ad_name_report/bind_groups/${id}`,
    method: 'PUT',
    data
  })
}
// 获取用户列表
export function launchTeamLeader(params = {}) {
  return request({
    url: `/common/user_list`,
    method: 'get',
    params
  })
}

// 广告统计
export function adCountList(params = {}) {
  return request({
    url: `/ad_copy/ad_num_list`,
    method: 'get',
    params
  })
}
// 素材统计
export function materialCountList(params = {}) {
  return request({
    url: `/ad_copy/material_statistics`,
    method: 'get',
    params
  })
}
// 投放组统计
export function groupCountList(params = {}) {
  return request({
    url: `/ad_copy/leader_statistics`,
    method: 'get',
    params
  })
}
// 投手统计
export function releaserCountList(params = {}) {
  return request({
    url: `/ad_copy/pitcher_statistics`,
    method: 'get',
    params
  })
}
// 投放组列表
export function adbasicreportgroupindex(params = {}) {
  return request({
    url: `/ad_basic_report/group/index`,
    method: 'get',
    params
  })
}
// 新增投放组
export function adbasicreportgroupstore(data = {}) {
  return request({
    url: `/ad_basic_report/group/store`,
    method: 'post',
    data
  })
}
// 修改投放组
export function adbasicreportgroupupdate(data = {}) {
  return request({
    url: `/ad_basic_report/group/update`,
    method: 'post',
    data
  })
}
// 绑定关系列表
export function adbasicreportbindindex(params = {}) {
  return request({
    url: `/ad_basic_report/bind/index`,
    method: 'get',
    params
  })
}
// 新增绑定关系
export function adbasicreportbindstore(data = {}) {
  return request({
    url: `/ad_basic_report/bind/store`,
    method: 'post',
    data
  })
}
// 修改绑定关系
export function adbasicreportbindupdate(data = {}) {
  return request({
    url: `/ad_basic_report/bind/update`,
    method: 'post',
    data
  })
}
// 设置绑定状态
export function adbasicreportbindsetstatus(data = {}) {
  return request({
    url: `/ad_basic_report/bind/set_status`,
    method: 'post',
    data
  })
}
// 投手基建数据列表
export function adbasicreportreportindex(params = {}) {
  return request({
    url: `/ad_basic_report/report/index`,
    method: 'get',
    params
  })
}
// 导出投手基建数据
export function adbasicreportreportexport(data = {}) {
  return request({
    url: `/ad_basic_report/report/export`,
    method: 'post',
    data
  })
}
// 小程序列表
export function miniprogramindex(params = {}) {
  return request({
    url: `/program_manage/mini_program/index`,
    method: 'get',
    params
  })
}
// 广告金转出记录列表
export function transferLog(params = {}) {
  return request({
    url: `/program_manage/mini_program/transfer_log`,
    method: 'get',
    params
  })
}
// 转出广告金
export function mini_programTransfer(data = {}) {
  return request({
    url: `/program_manage/mini_program/transfer`,
    method: 'post',
    data
  })
}
// 请求授权地址
export function programmanageminiprogramofficial(params = {}) {
  return request({
    url: `/program_manage/mini_program/official`,
    method: 'get',
    params
  })
}
// 小程序链接列表
export function programmanageurlLinkindex(params = {}) {
  return request({
    url: `/program_manage/urlLink/index`,
    method: 'get',
    params
  })
}
// 新增小程序链接
export function programmanageurlLinkadd(data = {}) {
  return request({
    url: `/program_manage/urlLink/add`,
    method: 'post',
    data
  })
}
